app.config(['$breadcrumbProvider', '$mdThemingProvider', '$logProvider', function ($breadcrumbProvider, $mdThemingProvider, $logProvider) {
    $breadcrumbProvider.setOptions({
        templateUrl: '/ng-views/shared/partials/breadcrumbslist.html?v=' + global.version
    });

     var custom = $mdThemingProvider.extendPalette('indigo', {
        'hue-1': '300',
        '300': '#728097',
        '500': '#3777bc',
        '600': '#303543',
        'A100': '#ff8a80',
        'A200': '#303543',
        'A400': '#ff1744',
        'A700': '#d50000'
    });
    // Register the new color palette map with the name <code>neonRed</code>
    $mdThemingProvider.definePalette('custom', custom);
    // Use that theme for the primary intentions
    $mdThemingProvider.theme('default')
      .primaryPalette('custom')
      .accentPalette('custom');

    $logProvider.debugEnabled(true);

}]);
